import drag from "./drag";
export default {
  drag
};
